<base-dialog>
  <div title>
    <h2>AGREGAR CAJA</h2>
  </div>
  <div close>
    <button mat-icon-button color="warn">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div content>
    <form
      name="form"
      *ngIf="form"
      [formGroup]="form"
      autocomplete="off"
      fxLayout="column"
      fxLayoutAlign=" center"
      fxLayoutGap="12px"
    >
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Número Punto Emisión</mat-label>
        <input matInput formControlName="number" />
        <mat-icon
          matSuffix
          class="secondary-text"
          [matTooltip]="notification.number"
          [ngClass]="{ 'error-icon': controlHasError('number') }"
          >class</mat-icon
        >
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>SRI Ambiente</mat-label>
        <mat-select formControlName="sriEnvironment">
          <mat-option
            *ngFor="let sriEnv of cashRegCatalogs?.getAllCashRegSriEnv"
            [value]="sriEnv?.id"
          >
            {{ sriEnv?.name }}
          </mat-option>
        </mat-select>
        <mat-icon
          matSuffix
          class="secondary-text"
          [matTooltip]="notification.sriEnvironment"
          [ngClass]="{ 'error-icon': controlHasError('sriEnvironment') }"
          >class</mat-icon
        >
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Nombre Caja</mat-label>
        <input matInput formControlName="name" />
        <mat-icon
          matSuffix
          class="secondary-text"
          [matTooltip]="notification.name"
          [ngClass]="{ 'error-icon': controlHasError('name') }"
          >class</mat-icon
        >
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Tipo caja</mat-label>
        <mat-select formControlName="type">
          <mat-option
            *ngFor="let crType of cashRegCatalogs?.getAllCashRegType"
            [value]="crType?.id"
          >
            {{ crType?.name }}
          </mat-option>
        </mat-select>
        <mat-icon
          matSuffix
          class="secondary-text"
          [matTooltip]="notification.type"
          [ngClass]="{ 'error-icon': controlHasError('type') }"
          >class</mat-icon
        >
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Actividad económica</mat-label>
        <mat-select formControlName="economicActivity">
          <mat-option *ngFor="let activ of activList" [value]="activ?.id">
            {{ activ?.description }}
          </mat-option>
        </mat-select>
        <mat-icon
          matSuffix
          class="secondary-text"
          [matTooltip]="notification.activity"
          [ngClass]="{ 'error-icon': controlHasError('economicActivity') }"
          >class</mat-icon
        >
      </mat-form-field>
    </form>
  </div>
  <div actions>
    <button
      mat-raised-button
      color="primary"
      class="submit-button w-button"
      [disabled]="!form.valid || isLoading"
      (click)="submit()"
    >
      <div class="loadingComponent" *ngIf="isLoading">
        <app-loading [isLoading]="isLoading" class="loadingComponent" />
      </div>
      <span *ngIf="!isLoading">{{ txtBtn }}</span>
    </button>
  </div>
</base-dialog>
